import React, { useState, useEffect } from "react";
import {
  FileContainer,
  FileHeader,
  ContPages,
  Actions,
  File,
  FileContent,
  TitleContainer,
  DocumentName,
} from "./styles";
import { faDownload, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from "components/Icon";
import PropTypes from "prop-types";
import { Label } from "../Form/";
import ModalIframe from './ModalIframe';
const { REACT_APP_BASE_URL_API } = process.env;

const propTypes = {
  documents: PropTypes.any,
};

export default function FileModal({ documents, actions = true }, ...props) {
  const [numDocuments, setNumDocuments] = useState(0);
  const [index, setIndex] = useState(0);
  const [loadDocument, setLoadDocument] = useState(false);
  const [currentKey, setCurrentKey] = useState(Math.random());

  function printDiv() {
    if (documents[index].reportToken) {
      var iframe = document.getElementById("pdf");
      iframe.src = `${REACT_APP_BASE_URL_API}/v2/report/${documents[index].reportToken}/pdf/${documents[index].fileName}`;
    }
  }

  function printContentPdf() {
    const iframe = document.getElementById("pdf");
    if (iframe.getAttribute("src")) {
      iframe.contentWindow.print();
    }
  }

  function handlePrevious() {
    if (index === 0) {
      return;
    }
    setIndex(index - 1);
  }

  function handleNext() {
    if (index + 1 < numDocuments) {
      setIndex(index + 1);
    }
    return;
  }

  function handleOpenfile() {
    if (documents[index].url) window.open(documents[index].url, "_blank");
    else if (documents[index].documentMetadata?.lnkAccess) window.open(documents[index].documentMetadata?.lnkAccess, "_blank")
    else if (documents[index].reportToken) window.open(`${REACT_APP_BASE_URL_API}/v2/report/${documents[index].reportToken}/pdf/${documents[index].fileName}`, "_blank");
    return;
  }

  useEffect(() => {
    setLoadDocument(true)
    setTimeout(() => setLoadDocument(false), 200)
    setCurrentKey(Math.random())
  }, [index])

  useEffect(() => {
    setNumDocuments(documents?.length || 1);
  }, [documents]);

  return (
    <FileContainer>
      {!documents || documents.length === 0 ? (
        ""
      ) : (
        <>
          <FileHeader>
            <TitleContainer>
              <DocumentName>
                {documents[index].idDomainDescription ? documents[index].idDomainDescription : "File Name"}
              </DocumentName>
              <ContPages>
                <Icon
                  onClick={() => handlePrevious()}
                  name={"arrowLeftWhite"}
                  style={{ marginRight: "10px" }}
                />
                Document {index < numDocuments ? index + 1 : index} of{" "}{numDocuments}
                <Icon
                  onClick={() => handleNext()}
                  name={"arrowRightWhite"}
                  style={{ marginLeft: "10px" }}
                />
              </ContPages>
            </TitleContainer>
            <Actions>
              {actions && (
                <>
                  <Label onClick={() => printDiv()}>
                    <FontAwesomeIcon icon={faPrint} size="lg" color="#FFF" />
                  </Label>
                  <Label onClick={() => handleOpenfile()}>
                    <FontAwesomeIcon icon={faDownload} size="lg" color="#FFF" />
                  </Label>
                </>
              )}
            </Actions>
          </FileHeader>

          <div style={{ overflowX: 'auto' }}>
            <FileContent>
              {documents[index].url && <object data={documents[index].url} type="application/pdf" width="100%" height="1000px">
                <p>
                  <a href={documents[index].url} target="_blank">Clique aqui para baixar seu arquivo!</a>
                </p>
              </object>}

              {!loadDocument && <ModalIframe key={currentKey} reportToken={documents[index].reportToken} />}
            </FileContent>
          </div>

          <iframe
            id={"pdf"}
            onLoad={() => printContentPdf()}
            style={{ display: "none" }}
          ></iframe>
        </>
      )}
    </FileContainer>
  );
}

FileModal.propType = propTypes;
